class DetailsDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );

    if (this.querySelector("#DetailsDrawer-Overlay")) {
      this.querySelector("#DetailsDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
    }

    this.id = this.getAttribute("id");

    document.querySelectorAll("[open-drawer]").forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();

        if (el.getAttribute("data-drawer-id") === this.id) {
          this.open(e.target);
        }
        // this.open(e.target);
      });
    });

    // document.querySelectorAll("[open-ask-us-drawer]").forEach((el) => {
    //   el.addEventListener("click", (e) => {
    //     e.preventDefault();
    //     this.open(e.target);
    //   });
    // });
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("DetailsDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }
}

customElements.define("details-drawer", DetailsDrawer);
